export default __webpack_public_path__ + "static/media/keto_alcohol@2x.a3c0dede.jpg";